/**
 * Çalışmakta olan AI turunun sohbet kimliği — Zustand, yalnızca bellekte.
 * Sayfa değişse de tur sunucuda sürer; bu durum kayan düğme, menü ve panelde "AI çalışıyor" işareti için tutulur.
 */
import { create } from 'zustand'

interface AiActivityState {
  runningConversationId: string | null
  /** Sohbet çalışıyorsa kimliği yazar; durduysa yalnızca o sohbet kayıtlıysa temizler */
  setRunning: (conversationId: string, running: boolean) => void
}

export const useAiActivityStore = create<AiActivityState>((set) => ({
  runningConversationId: null,
  setRunning: (conversationId, running) => set((s) => {
    if (running) return { runningConversationId: conversationId }
    return s.runningConversationId === conversationId ? { runningConversationId: null } : s
  }),
}))
